import { createGlobalStyle } from 'styled-components'
import { makeGlobalStyles } from './styles'

const GlobalStyles = createGlobalStyle`
  ${props => makeGlobalStyles(props)}
`

export default GlobalStyles
